import { render } from "./qrcode.vue?vue&type=template&id=3471bc3f&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=js"
export * from "./qrcode.vue?vue&type=script&lang=js"

import "./qrcode.vue?vue&type=style&index=0&id=3471bc3f&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3471bc3f"]])

export default __exports__